/* Presentation for the imported sculptures; preserve the real Tee and Shopify controls. */
(() => {
  function initialize() {
    const dataNode = document.getElementById('np-sculpture-data');
    if (!dataNode || dataNode.dataset.npPresentationBound) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    const section = document.querySelector('[id^="MainProduct-"]');
    const info = section?.querySelector('.product__info-container');
    if (!section || !info || !Array.isArray(data?.variants)) return;
    dataNode.dataset.npPresentationBound = 'true';
    const media = section.querySelector('.product__media-wrapper');
    const mainForm = () => info.querySelector('product-form.main-product-form form[action*="/cart/add"]');
    const currentVariant = () => data.variants.find(variant => String(variant.id) === String(mainForm()?.querySelector('[name="id"]')?.value)) || data.variants[0];
    const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: data.currency || 'USD' });
    const abort = new AbortController();
    let frame = 0;
    let livePreviewRequested = false;

    function ensureQuantity() {
      const form = mainForm();
      const atc = form?.querySelector('button[type="submit"][name="add"]');
      if (!atc || atc.closest('.np-bakven-purchase-row')) return;
      const row = document.createElement('div');
      row.className = 'np-bakven-purchase-row';
      atc.before(row);
      let quantity = form.querySelector('[name="quantity"]');
      if (quantity) {
        const existing = quantity.closest('quantity-input, .product-form__quantity');
        if (existing) row.append(existing);
      } else {
        const control = document.createElement('div');
        control.className = 'np-bakven-quantity';
        const minus = document.createElement('button');
        minus.type = 'button';
        minus.textContent = '−';
        minus.setAttribute('aria-label', 'Decrease quantity');
        quantity = document.createElement('input');
        quantity.type = 'number';
        quantity.name = 'quantity';
        quantity.value = '1';
        quantity.min = '1';
        quantity.step = '1';
        quantity.setAttribute('aria-label', 'Quantity');
        const plus = document.createElement('button');
        plus.type = 'button';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'Increase quantity');
        const changeQuantity = direction => {
          const rule = currentVariant()?.quantity_rule || {};
          const minimum = Number(rule.min) || 1;
          const increment = Number(rule.increment) || 1;
          const maximum = Number(rule.max) || Infinity;
          const next = Math.max(minimum, Math.min(maximum, (Number(quantity.value) || minimum) + direction * increment));
          quantity.value = String(next);
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        };
        minus.addEventListener('click', () => changeQuantity(-1), { signal: abort.signal });
        plus.addEventListener('click', () => changeQuantity(1), { signal: abort.signal });
        control.append(minus, quantity, plus);
        row.append(control);
      }
      row.append(atc);
    }

    function updateSavings() {
      const price = info.querySelector('[id^="price-"], [id^="main-price-"]');
      if (!price) return;
      let savings = info.querySelector('.np-bakven-savings');
      if (!savings) {
        savings = document.createElement('p');
        savings.className = 'np-bakven-savings';
        price.after(savings);
      }
      const variant = currentVariant();
      const difference = Number(variant?.compare_at_price) - Number(variant?.price);
      const text = difference > 0 ? `You Save ${Math.floor(difference / variant.compare_at_price * 100)}% (${currency.format(difference / 100)})` : '';
      if (savings.textContent !== text) savings.textContent = text;
      savings.hidden = !text;
    }

    function prepareFields() {
      for (const input of section.querySelectorAll('variant-selects .color-swatch input[type="radio"]')) {
        if (input.getAttribute('aria-label') !== input.value) input.setAttribute('aria-label', input.value);
        const label = input.closest('.color-swatch')?.querySelector('label');
        if (label && label.title !== input.value) label.title = input.value;
      }
      const inputs = info.querySelector('#teeFormInputs');
      if (!inputs) return;
      if (Number(data.productId) === 15443728531755) {
        const design = inputs.querySelector('.tee-field--template');
        if (design && inputs.firstElementChild !== design) inputs.prepend(design);
      }
      for (const input of inputs.querySelectorAll('input[type="text"], textarea')) {
        const heading = input.closest('.tee-field')?.querySelector('.tee-field__heading');
        if (!heading || input.maxLength <= 0) continue;
        let counter = heading.querySelector('.np-bakven-counter');
        if (!counter) {
          counter = document.createElement('span');
          counter.className = 'np-bakven-counter';
          const asterisk = heading.querySelector('.tee-asterisk');
          if (asterisk) asterisk.before(counter); else heading.append(counter);
        }
        const text = `(${input.value.length}|${input.maxLength})`;
        if (counter.textContent !== text) counter.textContent = text;
      }
    }

    function ensureDescription() {
      if (info.querySelector('.np-bakven-description')) return;
      const description = document.querySelector('#np-product-details .np-rich-description');
      if (!description) return;
      description.classList.add('np-bakven-description');
      info.append(description);
    }

    function ensurePreviewModal() {
      const modal = document.querySelector('.vm--modal[role="dialog"]');
      const footer = modal?.querySelector('.tee-dcontent-footer');
      if (!modal || !footer || modal.dataset.npPreviewBound) return;
      modal.dataset.npPreviewBound = 'true';
      const heading = document.createElement('h3');
      heading.className = 'np-bakven-preview-title';
      heading.textContent = 'Preview Your Product';
      modal.querySelector('.tee-dcontent-body')?.before(heading);
      const control = document.createElement('div');
      control.className = 'np-bakven-quantity np-bakven-preview-quantity';
      const minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.setAttribute('aria-label', 'Decrease preview quantity');
      const input = document.createElement('input');
      input.type = 'number';
      input.min = '1';
      input.step = '1';
      input.value = mainForm()?.querySelector('[name="quantity"]')?.value || '1';
      input.setAttribute('aria-label', 'Preview quantity');
      const plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase preview quantity');
      const sync = delta => {
        const native = mainForm()?.querySelector('[name="quantity"]');
        if (!native) return;
        const rule = currentVariant()?.quantity_rule || {};
        const value = Math.max(Number(rule.min) || 1, Math.min(Number(rule.max) || Infinity, (Number(input.value) || 1) + delta * (Number(rule.increment) || 1)));
        native.value = input.value = String(value);
        native.dispatchEvent(new Event('change', { bubbles: true }));
      };
      minus.addEventListener('click', () => sync(-1), { signal: abort.signal });
      plus.addEventListener('click', () => sync(1), { signal: abort.signal });
      input.addEventListener('change', () => sync(0), { signal: abort.signal });
      control.append(minus, input, plus);
      footer.prepend(control);
      requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }

    function showPreview() {
      // The shared POD gallery keeps product photos; Review opens the real Tee preview.
      if (media?.hasAttribute('data-np-pod-gallery')) return;
      livePreviewRequested = true;
      media?.classList.remove('np-bakven-show-photo');
      requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      const links = media?.querySelectorAll('[data-np-photo-src]') || [];
      links.forEach((link, index) => link.classList.toggle('is-current', index === 0));
    }

    function showPhoto(link) {
      if (!media) return;
      let stage = media.querySelector('.np-bakven-photo-stage');
      if (!stage) {
        stage = document.createElement('div');
        stage.className = 'np-bakven-photo-stage';
        stage.append(document.createElement('img'));
        media.prepend(stage);
      }
      const image = stage.querySelector('img');
      const source = link.dataset.npPhotoSrc;
      if (image.getAttribute('src') !== source) image.src = source;
      image.alt = link.dataset.npPhotoAlt || '';
      media.classList.add('np-bakven-show-photo');
      media.querySelectorAll('[data-np-photo-src]').forEach(item => item.classList.toggle('is-current', item === link));
    }

    function refresh() {
      ensureQuantity();
      const tee = info.querySelector('#tee-artwork-form');
      const row = tee?.closest('.np-bakven-purchase-row');
      if (row) row.before(tee);
      ensureDescription();
      updateSavings();
      prepareFields();
      ensurePreviewModal();
      // The source shows its original first photo until the buyer personalizes it.
      const first = media?.querySelector('[data-np-photo-src]');
      if (Number(data.productId) !== 15443728531755 && first && !livePreviewRequested && !media.querySelector('.np-bakven-photo-stage')) showPhoto(first);
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; refresh(); });
    }
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('#tee-artwork-form button.tee-btn--preview')) setTimeout(schedule, 50);
      const link = event.target.closest('.np-gallery-dock [data-np-photo-src]');
      if (!link || !media?.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      livePreviewRequested = true;
      showPhoto(link);
    }, { capture: true, signal: abort.signal });
    const onPersonalize = event => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('#tee-artwork-form, variant-selects')) showPreview();
      schedule();
    };
    section.addEventListener('input', onPersonalize, { signal: abort.signal });
    section.addEventListener('change', onPersonalize, { signal: abort.signal });
    const observer = new MutationObserver(schedule);
    observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
    const modalObserver = new MutationObserver(schedule);
    modalObserver.observe(document.body, { childList: true });
    window.addEventListener('pagehide', () => {
      abort.abort();
      observer.disconnect();
      modalObserver.disconnect();
      cancelAnimationFrame(frame);
    }, { once: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
